// @flow

import React, {Fragment, type Node} from 'react';
import styled from 'styled-components';

import {FlexPanel} from 'app/general/structures/FlexPanel';
import {NavSidebar} from './NavSidebar';
import {ErrorBoundary} from 'app/general/structures/ErrorBoundary';

const StyledBackdropDiv = styled.div`
  opacity: 0;
  visibility: hidden;
  z-index: 7;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.75);
  transition: 250ms;

  &.visible {
    opacity: 1;
    visibility: visible;
  }
`;

type Props = {
  children: Node,
  opened: boolean,
  onToggle: () => any,
};

export const NavSidebarContainer = ({children, opened, onToggle}: Props) => (
  <FlexPanel
    type="horizontal"
    secondaryZindex="8"
    secondary={
      <ErrorBoundary name="navsidebar">
        <NavSidebar opened={opened} onToggle={onToggle} />
      </ErrorBoundary>
    }
  >
    <Fragment>
      <StyledBackdropDiv
        className={opened ? 'visible' : ''}
        onClick={onToggle}
      />
      {children}
    </Fragment>
  </FlexPanel>
);
